import Command from '@ckeditor/ckeditor5-core/src/command';

export default class FormaCommand extends Command {
    execute() {
        this.editor.model.change(writer => {
            this.editor.model.insertContent(createForma(writer));
        });
    }

    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'formBox');

        this.isEnabled = allowedIn !== null;
    }
}

function createForma(writer) {
    const oprosId = prompt( 'Укажите ID формы' );
    if(oprosId === null || oprosId === ''){
        return writer.createElement('paragraph');
    }
    const formBox = writer.createElement('formBox');
    const oprosContainer = writer.createElement('form-in-material-component', {':form-id': oprosId});
    writer.append(oprosContainer, formBox);

    return formBox;
}
